function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LocaleKeys from '../../locales/keys';
var AddressSwitcherController = /*#__PURE__*/function () {
  function AddressSwitcherController($timeout) {
    _classCallCheck(this, AddressSwitcherController);
    this.$timeout = $timeout;
    this.showChangeAddressModal = false;
    this.closeChangeAddress = this.closeChangeAddress.bind(this);
    this.onChangeAddress = this.onChangeAddress.bind(this);
    this.onAddedAddress = this.onAddedAddress.bind(this);
    this.onUpdatedAddress = this.onUpdatedAddress.bind(this);
  }
  return _createClass(AddressSwitcherController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.LocaleKeys = LocaleKeys;
      this.changeAddressDialogConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.changeAddressDialogApi = event.api;
        }
      };
      this.createAddressPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.createAddressPopupApi = event.api;
        }
      };
      this.updateAddressPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.updateAddressPopupApi = event.api;
        }
      };
    }
  }, {
    key: "hasMultipleAddresses",
    value: function hasMultipleAddresses() {
      return this.addresses && this.addresses.length > 1;
    }
  }, {
    key: "openChangeAddress",
    value: function openChangeAddress() {
      this.showChangeAddressModal = true;
      this.$timeout(this.changeAddressDialogApi.open);
    }
  }, {
    key: "closeChangeAddress",
    value: function closeChangeAddress() {
      this.changeAddressDialogApi.close();
      this.showChangeAddressModal = false;
    }
  }, {
    key: "openNewAddressPopup",
    value: function openNewAddressPopup() {
      this.$timeout(this.createAddressPopupApi.open);
    }
  }, {
    key: "openUpdateAddressPopup",
    value: function openUpdateAddressPopup() {
      this.$timeout(this.updateAddressPopupApi.open);
    }
  }, {
    key: "onChangeAddress",
    value: function onChangeAddress(selectedAddress) {
      this.onChange()(selectedAddress);
      this.closeChangeAddress();
    }
  }, {
    key: "onAddedAddress",
    value: function onAddedAddress(addedAddress) {
      this.onAdded()(addedAddress);
    }
  }, {
    key: "onUpdatedAddress",
    value: function onUpdatedAddress(updatedAddress) {
      this.onUpdated()(updatedAddress);
    }
  }, {
    key: "showChange",
    value: function showChange() {
      return !this.isReadOnly && this.hasMultipleAddresses();
    }
  }, {
    key: "showEdit",
    value: function showEdit() {
      return !this.isReadOnly && this.currentAddress && this.currentAddress.Id;
    }
  }]);
}();
export default {
  template: require('./address.switcher.html'),
  bindings: {
    addresses: '<',
    currentAddress: '<',
    currentCustomerId: '<',
    isReadOnly: '<',
    onAdded: '&',
    onChange: '&',
    onUpdated: '&',
    shipToNameRequired: '<',
    showName: '<'
  },
  controller: AddressSwitcherController
};